<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-row dense v-if="user.tipo == 'ADMIN'">
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaLojistas(user.tipo == 'ADMIN' ? empresaSelecionada : companyobj.id); lojistaSelecionado = ''; tabela.conteudo = []"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="12" md="6" v-if="user.tipo == 'ADMIN_PRODUTORA' || user.tipo == 'ADMIN'">
        <v-select
          outlined
          dense
          v-model="lojistaSelecionado"
          :items="lojistas"
          item-text="nome"
          item-value="id"
          label="Selecione o lojista"
          @input="carregaCategorias(empresaSelecionada, lojistaSelecionado)"
        ></v-select>
      </v-col>
    </v-row>
    <!-- <v-row dense v-if="user.tipo == 'ADMIN_CategoriaRA'">
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="lojistaSelecionado"
          :items="lojistas"
          item-text="nome"
          item-value="id"
          label="Selecione o lojista"
          @input="carregaCategorias(user.empresaId, lojistaSelecionado)"
        ></v-select>
      </v-col>
    </v-row> -->
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12">
        <v-data-table
          :search="tabela.busca"    
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
        >
          <template v-slot:[`item.status`]="{ item }">
            <p style="margin: 0px">{{item.status == "ativo" ? 'Ativo' : 'Inativo'}}</p>
          </template>
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">CATEGORIAS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                append-icon="search"
                label="Pesquisa"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogoCategoria = true" tile color="#00253E" :disabled="user.tipo == 'ADMIN' ? (lojistaSelecionado == '') : false">
                <v-icon left dark>add_circle</v-icon>Adicionar Categoria
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn color="teal" icon @click="editItem(item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn color="red" icon @click="deleteItem(item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>

      <!-- CARD INSERE Categoria -->
      <v-dialog v-model="dialogoCategoria" persistent max-width="600px">
        <v-card>
          <v-card-title>{{ formTitleProd }}</v-card-title>
          <v-card-subtitle>*O preenchimento de todos os campos é obrigatório</v-card-subtitle>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-text-field v-model="categoria.descricao" outlined label="Descrição" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="categoria.ordem" outlined label="Ordem" color="#94AAB4" hide-details dense></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select outlined dense hide-details v-model="categoria.status" label="Status" color="#00253E" :items="selecaoStatus"></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="categoria.urlImagem" outlined label="URL Imagem" color="#94AAB4" hide-details dense></v-text-field>
                <v-img contain :src="categoria.urlImagem" height="100" width="100%" v-if="categoria.urlImagem" style="max-width: 100%; max-width: 130px; margin-top: 10px" class="mx-auto"></v-img>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="salvarCategoria">Salvar</v-btn>
            <v-btn text color="red" @click="dialogoCategoria = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: {Snackbar},
    data: () => ({
      date: new Date().toISOString().substr(0, 10),
      mask:"##:##:##",
      menu: false,
      menu2: false,
      search:'',
      addUser: false,
      cadastroCategoria: false,
      dialogoCategoria: false,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Ordem', value: 'ordem' },
          { text: 'Descrição', value: 'descricao' },
          { text: 'Status', value: 'status' },
          { text: 'Ações', value: 'action',  sortable: false, align: 'center' },
        ],
        carregamento: false,
        conteudo: [],
      },
      empresaSelecionada: '',
      lojistaSelecionado: '',
      empresas: [],
      perfis: [],
      editedIndex: -1,
      categoria: {
        descricao: "",
        status: "ativo",
        urlImagem: "",
        empresaId: "",
        ordem: "",
        lojistaId: '',
      },
      categoriaDefault: {
        descricao: "",
        status: "ativo",
        urlImagem: "",
        empresaId: "",
        ordem: "",
        lojistaId: '',
      },
      lojistas: [],
      events: [],
      categorias: [],
      selecaoStatus: [
        { text: 'Ativo', value: 'ativo'},
        { text: 'Inativo', value: 'inativo'},
      ]
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitleProd () {
        return this.editedIndex === -1 ? 'Adicionar nova categoria' : 'Editar categoria'
      },  
    }),

    watch: {
      dialogoCategoria(val) {
        if (val == false) {
          setTimeout(() => {
            this.categoria = Object.assign({}, this.categoriaDefault)
            this.editedIndex = -1
          }, 300)
        }
      },
    },

    mounted () {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else if (this.user.tipo == 'ADMIN_PRODUTORA') {
        this.carregaLojistas(this.user.empresaId)
      } else {
        this.carregaCategorias(this.companyobj.id, this.user.lojistaId)
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaLojistas(empresaId) {
        await axios.get(baseApiUrl + 'Lojistas?filter={"where":{"empresaId":"' + empresaId + '"}, "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.lojistas = response.data
          }
        })
      },

      async carregaCategorias(empresaId, lojistaId) {
        this.tabela.conteudo = []
        this.tabela.carregamento = true

        await axios.get(baseApiUrl + 'Categorias?filter={"where":{"and":[{"empresaId":"' + empresaId + '"},{"lojistaId":"' + lojistaId + '"}]}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.tabela.conteudo = response.data
          }
        })
        .catch(() => {
          this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao buscar categorias. Tente novamente.", "ERRO")
        })

        this.tabela.carregamento = false
      },


      editItem(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.categoria = Object.assign({}, item)
        this.dialogoCategoria = true
      },

      async deleteItem(item) {
        var r = confirm('Deseja realmente excluir a categoria: ' + item.descricao + '?')
        if (r == true) {
          try {
            await axios.delete(`${baseApiUrl}Categorias/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
            this.carregaCategorias(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id, this.user.tipo == 'ADMIN' ? this.lojistaSelecionado : this.user.lojistaId)
          } catch (error) {
            var vm;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
          }
        }
      },

      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      async salvarCategoria() {
        var vm = this

        if (this.categoria.descricao && this.categoria.ordem && this.categoria.status) {
           this.categoria.empresaId = this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id
           this.categoria.lojistaId = this.user.tipo == 'ADMIN' ? this.lojistaSelecionado : this.user.lojistaId

          await axios.post(baseApiUrl + 'Categorias/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.categoria)
          .then(response => {
            if (response.data) {
              this.categoria = Object.assign({}, this.categoriaDefault)
              this.dialogoCategoria = false
              this.carregaCategorias(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id, this.user.tipo == 'ADMIN' ? this.lojistaSelecionado : this.user.lojistaId)
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar operação, tente novamente", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos!", "ATENÇÃO")
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }
</style>
